import { createReducer } from '@reduxjs/toolkit';
import { setStaticPrefixes } from './prefix.action';
import { Prefix } from './prefix.types';

const initialState = {
  prefixes: {} as Record<string, Prefix>,
};

const prefixReducer = createReducer(initialState, (builder) => {
  builder.addCase(setStaticPrefixes, (state, { payload }) => {
    state.prefixes = Object.fromEntries(
      payload.map((prefix) => [prefix.sign, prefix]),
    );
  });
});

export default prefixReducer;
